import { QuestionWrapper, Card } from '../../components';
import { useTranslation } from 'react-i18next';
import { Row, Col, Typography } from 'antd';
import { formatCurrency } from 'common/services/currency';

interface Props {
  monthlyInvestingPlan: number;
  oneTimeProvision: number;
  monthlyProvision: number;
  oneTimeInvesting: number;
}

export default function AnalyseConclusion(props: Props) {
  const { t } = useTranslation();
  return (
    <div className="analyse-conclusion">
      <QuestionWrapper>
        <QuestionWrapper.Divider>
          <Card>
            <Row gutter={30}>
              <Col xs={12}>
                <Typography.Paragraph>{t('analyseConclusion.monthlyInvestingPlan')}</Typography.Paragraph>
                <Typography.Title level={4}>{formatCurrency(props.monthlyInvestingPlan)}</Typography.Title>
              </Col>
              <Col xs={12}>
                <Typography.Paragraph>{t('analyseConclusion.oneTimeInvesting')}</Typography.Paragraph>
                <Typography.Title level={4}>{formatCurrency(props.oneTimeInvesting)}</Typography.Title>
              </Col>
            </Row>
          </Card>
          <QuestionWrapper.Title>{t('analyseConclusion.forPartnerTitle')}</QuestionWrapper.Title>
          <Card>
            <Row gutter={30}>
              <Col xs={24} md={12}>
                <Typography.Paragraph>{t('analyseConclusion.oneTimeProvision')}</Typography.Paragraph>
                <Typography.Title level={4}>{formatCurrency(props.oneTimeProvision)}</Typography.Title>
              </Col>
              <Col xs={24} md={12}>
                <Typography.Paragraph>{t('analyseConclusion.monthlyProvision')}</Typography.Paragraph>
                <Typography.Title level={4}>{formatCurrency(props.monthlyProvision)}</Typography.Title>
              </Col>
            </Row>
          </Card>
        </QuestionWrapper.Divider>
      </QuestionWrapper>
    </div>
  );
}
